import { render, staticRenderFns } from "./CampaignsDate.vue?vue&type=template&id=1fff93e1&lang=pug"
import script from "./CampaignsDate.vue?vue&type=script&lang=js"
export * from "./CampaignsDate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports